import { Config } from 'ha/config';

import { RenderFn, FeatureStatus, FeatureFlags } from '../types';

interface OwnProps {
  feature: FeatureFlags;
  envFeatures: Config['features'];
  children: RenderFn;
}

export const EnvFlag: React.SFC<OwnProps> = ({
  feature,
  children,
  envFeatures,
}) =>
  children(
    envFeatures[feature] === true || envFeatures[feature] === 'on'
      ? FeatureStatus.ENABLED
      : FeatureStatus.DISABLED,
  );

export default EnvFlag;
